import React from "react";
import { Skeleton } from "../common/Skeleton";
import { CardSkeleton } from "./CardSkeleton";

export function PageSkeleton({ className = "" }) {
  return (
    <div className={`min-h-[50vh] w-full p-4 md:p-6 ${className}`}>
      <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="space-y-2">
          <Skeleton className="h-9 w-48 md:w-64" />
          <Skeleton className="h-4 w-full max-w-md" />
        </div>
        <Skeleton className="h-10 w-32 shrink-0" />
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
      <div className="mt-8 space-y-3">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-32 w-full rounded-lg" />
      </div>
    </div>
  );
}

export default PageSkeleton;
